class Question < ApplicationRecord
  belongs_to :billable
end
